module.exports = " <div class=CenterColumn> <div class=CenterColumn__container> <slot></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/columns/Centercolumn.vue
// module id = 482
// module chunks = 1